<template lang="pug">
vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="information__wrapper")
  vm-col.card(vm-sm=12)
    vm-row(vm-align="left" vm-type="flex" vm-justify="left" vm-w="12")
      h3.purchase__order_title Importaciones &nbsp
      h4 "Todos los montos son en M.N."
      vm-col(vm-sm=12)
        vm-table(max-height="500px" :data="purchaseOrders")
          template(slot="header")
            .d-flex.justify-content-between
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsNewImports") {{ $t('sale_imports.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsNewImports")
                .row
                  slot(v-if="column == 'supplier_name'") {{ data[indextr]['supplier']['name'] }}
                  slot(v-if="column == 'total_cost'") {{ data[indextr]['subtotal'] | currency }}
                  slot(v-if="column == 'total_cost_mxn'") {{ data[indextr]['subtotal_mxn'] | currency }}
                  slot(v-if="column == 'import_total'") {{ importNewTotal(indextr) | currency }}
                  .input__wrapper(v-if="column == 'type'")
                    vm-select(:placeholder='$t("sale_imports.type")' :danger-text="'type is required'" v-model="data[indextr].type" @change="typeChange(indextr)")
                      vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in types")
                  .input__wrapper(v-if="column == 'percent'")
                    vm-input(:danger-text="'percent is required'" v-model="data[indextr].percent" :disabled="data[indextr].type !== 2" type="number")
                  .input__wrapper(v-if="column == 'amount'")
                    vm-input(:danger-text="'amount is required'" v-model="data[indextr].amount" :disabled="data[indextr].type !== 1" type="number")
      vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="9" class="gutters")
      vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="3" class="gutters")
        vm-button(style="width:80%;" @click="saveImports()") Guardar
      vm-col.bottom_margin(vm-sm=12)
        vm-table(max-height="500px" :data="imports")
          template(slot="header")
            .d-flex.justify-content-between
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsImports") {{ $t('sale_imports.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsImports")
                .row
                  slot(v-if="column == 'supplier_name'") {{ data[indextr]['supplier']['name'] }}
                  slot(v-if="column == 'total_cost'") {{ orderCost(indextr, data[indextr]['supplier_id']) | currency }}
                  slot(v-if="column == 'total_cost_mxn'") {{ orderCostMxn(indextr, data[indextr]['supplier_id']) | currency }}
                  slot(v-if="column == 'amount'") {{ data[indextr][column] | currency }}
                  slot(v-if="column == 'percent'") {{ data[indextr][column] }}
                  slot(v-if="column == 'import_total'") {{ importTotal(indextr, data[indextr]['supplier_id']) | currency }}
                  slot(v-if="column == 'actions' && $auth.check('Admin')")
                    .actions__wrapper
                      vm-button(type="flat" icon="trash-2-outline" color="rgb(242, 19, 93)" @click="deleteImports(data[indextr], tr)")
  vm-col.card(vm-sm=12)
    vm-row(vm-align="left" vm-type="flex" vm-justify="left" vm-w="12")
      h3.purchase__order_title Otros Gastos
      vm-col(vm-sm=12)
      vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters")
        b-form-group
          vm-input(:label='$t("sale_other_expenses.concept")' :placeholder='$t("sale_other_expenses.concept")' v-model="newExpense.concept")
      vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters")
        b-form-group
          vm-input(:label='$t("sale_other_expenses.amount_mxn")' :placeholder='$t("sale_other_expenses.amount")' v-model="newExpense.amount" type="number")
      vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters")
        b-form-group
          vm-date-picker(style="width:80%;" :placeholder='$t("strings.select_date")' type="date" :label='$t("strings.payment_date")' @on-change="handleChange" :value="expenseDate" v-model="newExpense.expense_date")
      vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="9" class="gutters")
      vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="3" class="gutters")
        vm-button(style="width:80%;" @click="saveExpenses()") Guardar
      vm-col.bottom_margin(vm-sm=12)
        vm-table(max-height="500px" :data="expenses")
          template(slot="header")
            .d-flex.justify-content-between
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsExpenses") {{ $t('sale_other_expenses.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsExpenses")
                .row
                  slot(v-if="column == 'amount_mxn'") {{ data[indextr]['amount'] | currency }}
                  slot(v-if="column == 'concept'") {{ data[indextr][column] }}
                  slot(v-if="column == 'expense_date'") {{ data[indextr][column] | moment('DD-MMMM-YYYY') }}
                  slot(v-if="column == 'actions' && $auth.check('Admin')")
                    .actions__wrapper
                      vm-button(type="flat" icon="trash-2-outline" color="rgb(242, 19, 93)" @click="deleteExpenses(data[indextr], tr)")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ImportOtherExpenses',
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    sale_id: null,
    expenseDate: new Date(),
    newExpense: {
      sale_id: null,
      amount: null,
      concept: '',
      expense_date: new Date()
    },
    columnsNewImports: [
      'supplier_name',
      'total_cost',
      'total_cost_mxn',
      'type',
      'amount',
      'percent',
      'import_total'
    ],
    columnsImports: [
      'supplier_name',
      'total_cost',
      'total_cost_mxn',
      'amount',
      'percent',
      'import_total',
      'actions'
    ],
    columnsExpenses: [
      'concept',
      'amount_mxn',
      'expense_date',
      'actions'
    ],
    types: [
      {
        text: 'Monto',
        value: 1
      },
      {
        text: 'Porcentaje',
        value: 2
      }
    ]
  }),
  validations: {
    newImport: {
      type: {
        required
      },
      amount: {
        required: requiredIf(function (newImport) {
          return newImport.type === 1
        })
      },
      percent: {
        required: requiredIf(function (newImport) {
          return newImport.type === 2
        })
      }
    },
    newExpense: {
      amount: {
        required
      },
      concept: {
        required
      },
      expense_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters(['purchaseOrders', 'imports', 'expenses'])
  },
  watch: {
  },
  async created () {
    await this.loadSaleInformation({ sale_id: this.$route.params.id }).then(() => {
      this.loadPurchaseOrders({ sale_id: this.sale.id })
    })
    await this.loadImports({ sale_id: this.sale.id })
    await this.loadExpenses({ sale_id: this.sale.id })
  },
  methods: {
    ...mapActions([
      'loadSaleInformation',
      'loadPurchaseOrders',
      'loadImports',
      'loadExpenses',
      'addImport',
      'addExpense',
      'deleteImport',
      'deleteExpense'
    ]),
    ordersList () {
      this.purchaseOrders.map((order) => {
        order.sale_id = this.sale.sale_id
        order.supplier_id = order.supplier_id
        order.amount = 0.00
        order.percent = 0.00
        return order
      })
    },
    async saveImports () {
      this.purchaseOrders.map((order) => {
        let newImport = {
          sale_id: this.sale.id,
          supplier_id: order.supplier_id,
          amount: order.amount,
          percent: order.percent
        }
        if (newImport.amount != null || newImport.percent != null) {
          this.addImport({ sale_id: this.$route.params.id, data: newImport }).then(() => {
            this.loadImports({ sale_id: this.sale.id }).then(() => {
              this.newImport = {}
            })
          })
        } else {
          this.newImport = {}
        }
      })
      await this.loadSaleInformation({ sale_id: this.$route.params.id }).then(() => {
        this.loadPurchaseOrders({ sale_id: this.sale.id })
      })
    },
    async saveExpenses () {
      this.newExpense.sale_id = this.$route.params.id
      await this.addExpense({ sale_id: this.$route.params.id, data: this.newExpense }).then(() => {
        this.loadExpenses({ sale_id: this.sale.id }).then(() => {
          this.newImport = {
            amount: null,
            concept: '',
            expense_date: new Date()
          }
        })
      })
      await this.loadSaleInformation({ sale_id: this.$route.params.id }).then(() => {
        this.loadPurchaseOrders({ sale_id: this.sale.id })
      })
    },
    async deleteImports (detail) {
      let t = this
      this.auxImport = () => {
        t.deleteImport({ sale_id: this.$route.params.id, import: detail.id }).then(() => {
          this.loadImports({ sale_id: this.sale.id })
        })
        t.loadSaleInformation({ sale_id: this.$route.params.id }).then(() => {
          this.loadPurchaseOrders({ sale_id: this.sale.id })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.sale-import'), attribute: '' }),
        accept: this.auxImport
      })
    },
    async deleteExpenses (detail) {
      let t = this
      this.auxExpense = () => {
        t.deleteExpense({ sale_id: this.$route.params.id, expense: detail.id }).then(() => {
          this.loadExpenses({ sale_id: this.sale.id })
        })
        t.loadSaleInformation({ sale_id: this.$route.params.id }).then(() => {
          this.loadPurchaseOrders({ sale_id: this.sale.id })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.sale-expense'), attribute: '' }),
        accept: this.auxExpense
      })
    },
    orderCost (index, supplier) {
      const order = this.purchaseOrders.find(order => order.supplier_id === supplier)
      return order.subtotal
    },
    orderCostMxn (index, supplier) {
      const order = this.purchaseOrders.find(order => order.supplier_id === supplier)
      return order.subtotal_mxn
    },
    importNewTotal (index) {
      return this.purchaseOrders[index].type === 1 ? this.purchaseOrders[index].amount : this.purchaseOrders[index].subtotal_mxn * (this.purchaseOrders[index].percent / 100)
    },
    importTotal (index, supplier) {
      const order = this.purchaseOrders.find(order => order.supplier_id === supplier)
      return this.imports[index].amount !== '0.00' ? this.imports[index].amount : order.subtotal_mxn * (this.imports[index].percent / 100)
    },
    handleChange (date) {
      this.expenseDate = date
    },
    typeChange (index) {
      if (this.purchaseOrders[index].type === 1) {
        this.purchaseOrders[index].percent = '0.00'
      } else {
        this.purchaseOrders[index].amount = '0.00'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.information__wrapper {
  margin-top: 25px;
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon__wrapper {
        padding: 10px !important;
        border-radius: 0.5em;
        background-color: #dfdfdf;
      }
    }
  }
}

.purchase__order_title {
  font-weight: bold;
}

.text__helper {
  font-size: 16px;
  text-align: center;
}

.list__wrapper_supplier,
.list__wrapper_purchase {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 25px;
  padding-left: 0 !important;
  .list__item__wrapper {
    width: 100%;
    padding-left: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #94949493;
    .radio__button {
      padding: 10px;
      cursor: pointer;
    }
    .text__purchase {
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;
    }
    .status__display {
      font-size: 12px;
      border-radius: 0.5em;
      box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.2);
      padding: 5px 10px;
      color: #fff;
      cursor: pointer;
    }
  }
}

.text__supplier {
  color: #026481;
  font-weight: bold;
}

.table {
  padding-left: 0 !important;
  .vm-table-text {
    padding-left: 0 !important;
  }
}
/* Helpers */
.gutters {
  padding: 20px;
}
.h-100 {
  height: 100%;
}

.p-0 {
  padding: 0 !important;
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom_margin {
  margin-bottom: 40px;
}
</style>
